import { ThemeProvider } from "@emotion/react";
import * as React from "react";

import clock from "assets/svg/clock.svg";
import { legacyTheme } from "themes/legacyTheme";

import { Container, Header, Headline, StepImage, Wrapper } from "./styled";

const TicketRatingExpired: React.FC = () => (
  <ThemeProvider theme={legacyTheme}>
    <Container>
      <Wrapper>
        <StepImage src={clock} />
        <Header>Oops, the link has expired.</Header>
        <Headline>You can no longer rate this ticket.</Headline>
      </Wrapper>
    </Container>
  </ThemeProvider>
);

export default TicketRatingExpired;
